<template>
  <div v-if="Lib.checkPower('beauty-4-ckkjsysr',2)">
    <customerTable v-if="update" ref="table" :array="table_col" :data="tableData" :change-tabs="changeTabs" :is-show-config="isShowConfig" :public-word="'订单号'" :loading="loading" @statisticsChange="statisticsChange" @timeChange="timeChange" @searchChange="searchChange" @onPrint="onPrint" />
    <el-pagination background layout="prev, pager, next" :total="total" :current-page.sync="currentPage" :page-size="10" @current-change="onGetFastIncome"></el-pagination>
  </div>
  <gt-noneData v-else :title="'暂无权限，请联系管理员分配权限'" :is-no-permission="true"></gt-noneData>
</template>

<script>
import dayjs from 'dayjs';
import api from '../../api/index.js';
import customerTable from '../others/customer_table';

export default {
  components: {
    customerTable
  },
  data() {
    return {
      timeRange: [
        dayjs().subtract(30, 'day').format('YYYY-MM-DD'),
        dayjs().format('YYYY-MM-DD')
      ],
      searchInput: '',
      tableData: [{}],
      table_col: [],
      update: true, // 刷新视图专用
      changeTabs: false, // 是否改变tabs
      isShowConfig: false, // 是否展示操作列
      total: 0,
      pageData: [],
      currentPage: 1,
      loading: true,
      // 5.8
      statisticsRange: '1'
    };
  },
  activated() {
    this.onGetFastIncome();
  },
  methods: {
    // 获取 快捷收银数据
    onGetFastIncome() {
      const vm = this;
      vm.loading = true;
      const data = {
        beginTime: this.timeRange[0],
        endTime: this.timeRange[1],
        text: this.searchInput,
        mainId: sessionStorage.getItem('mainId'),
        pageNum: this.currentPage,
        pageSize: 10,
        timeCountType: this.statisticsRange
      };
      api.getFastIncome(data).then((res) => {
        res.data.records.forEach((a) => {
          if (!a.payType) a.payType = '--';
          if (!a.remark) a.remark = '--';
          if (a.buySource == 0) {
            a.buySource = '电脑端';
          } else if (a.buySource == 1) {
            a.buySource = '粉丝端';
          } else if (a.buySource == 2) {
            a.buySource = '店员App';
          } else if (a.buySource == 3) {
            a.buySource = 'Smartbox';
          } else {
            a.buySource = '--';
          }
        });
        vm.tableData = res.data.records;
        vm.loading = false;
        vm.table_col = [
          {
            name: '开单时间',
            prop: 'payTime',
            showTip: false,
            tip: ''
          },
          {
            name: '订单号',
            prop: 'orderCode',
            showTip: false,
            tip: ''
          },
          {
            name: '订单金额',
            prop: 'countMoney',
            showTip: false,
            tip: ''
          },
          {
            name: '支付方式',
            prop: 'payType',
            showTip: false,
            tip: ''
          },
          {
            name: '操作人',
            prop: 'dutyName',
            showTip: false,
            tip: ''
          },
          {
            name: '订单来源',
            prop: 'buySource',
            showTip: false,
            tip: ''
          },
          {
            name: '备注',
            prop: 'remark',
            showTip: false,
            tip: ''
          }
        ];
        vm.isShowConfig = false;
        this.total = res.data.total;
      });
    },
    // 统计方式改变回调
    statisticsChange(val) {
      this.statisticsRange = val;
      this.onGetFastIncome();
    },
    // 时间改变回调
    timeChange(val) {
      this.timeRange = val;
      this.onGetFastIncome();
    },
    // 搜索框改变回调
    searchChange(val) {
      this.searchInput = val;
      this.onGetFastIncome();
    },
    // 分页数据处理函数
    pageDataFn(number) {
      // 处于第几页 number
      // 保存每页数据的函数
      const pagedata = [];
      // pagesize=10 每页条数
      // 设置开始
      const start = 10 * number - 10;
      // 设置结束长度
      let end = 10 * number; // 长度判断 //所有分页数据 this.tableData
      end = end > this.tableData.length ? this.tableData.length : end;
      for (let i = start; i < end; i++) {
        // 所有分页数据 this.tableData
        pagedata.push(this.tableData[i]);
      }
      this.pageData = pagedata;
      // //console.log(this.pageData)
    },
    // 打印
    onPrint() {
      if (this.Lib.checkPower('beauty-4-dykjsysr') == false) return;
      const data = {
        beginTime: this.timeRange[0],
        endTime: this.timeRange[1],
        text: this.searchInput,
        mainId: sessionStorage.getItem('mainId'),
        pageNum: 1,
        pageSize: 99999999,
        timeCountType: this.statisticsRange
      };
      api.getFastIncome(data).then((res) => {
        res.data.records ? '' : res.data.records = [];
        res.data.records.forEach((a) => {
          if (a.buySource == 0) {
            a.buySource = '电脑端';
          } else if (a.buySource == 1) {
            a.buySource = '粉丝端';
          } else if (a.buySource == 2) {
            a.buySource = '店员App';
          } else if (a.buySource == 3) {
            a.buySource = 'Smartbox';
          } else {
            a.buySource = '--';
          }
        });
        this.$print({ data: res.data.records, title: '快捷收银', table_tol: this.table_col });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.title {
    display: flex;
}
</style>
